import SlideVerify from './SlideVerify.vue';
import VoteButton from './VoteButton.vue';
import VoteList from './VoteList.vue';
import NewsList from './NewsList.vue';
import SearchInput from './SearchInput.vue';
import BottomTabbar from './BottomTabbar.vue';
import TextInput from './TextInput.vue';
import PickerInput from './PickerInput.vue';
import Uploader from './Uploader.vue';
import Banner from './Banner.vue';
import SyVoteList from './SyVoteList.vue';
import SyVoteItem from './SyVoteItem.vue';
export {
  SlideVerify,
  VoteButton,
  VoteList,
  SearchInput,
  BottomTabbar,
  NewsList,
  TextInput,
  PickerInput,
  Uploader,
  Banner,
  SyVoteList,
  SyVoteItem,
};
